export default {
  home: "หน้าเเรก",
  companyProfile: "โปรไฟล์ธุรกิจ",
  jobPost: "งาน",
  booking: "จองสัมภาษณ์",
};
